import React from 'react';
import { GuessEntry, LetterStatus } from '../types';

interface GuessRowProps {
  guess?: GuessEntry;
  rowIndex: number;
  reveal?: boolean;
}

const GuessRow: React.FC<GuessRowProps> = ({ guess, rowIndex, reveal = true }) => {
  const letters = guess ? guess.guess.split('') : Array(5).fill('');
  const statuses: Array<LetterStatus | ''> = guess ? guess.result : Array(5).fill('');

  return (
    <div className="game-row" key={`row-${rowIndex}`}>
      {letters.map((letter, idx) => {
        const status = statuses[idx];
        const statusClass = status ? `tile--${status}` : '';
        const revealClass = status ? 'tile--reveal' : '';
        return (
          <div
            key={`tile-${rowIndex}-${idx}`}
            className={`tile ${statusClass} ${reveal ? revealClass : ''}`}
          >
            {letter.toUpperCase()}
          </div>
        );
      })}
    </div>
  );
};

export default GuessRow;
